import { BUTTON_CTA_VARIANT } from "./product-block-display.js";

/** Same contract as legacy product upsell popups (ButtonBlock form_submit). */
export const AI_UPSELL_PRIMARY_CTA_ACTION = {
  type: "form_submit",
  parameters: { event: "product_add_cart" },
};

/**
 * Ensures AI Recommendation Upsell catalog CTA buttons have stable roles and actions.
 * @param {object[]} sections — step-level blocks
 */
export function ensureAiRecommendationUpsellCatalogCtaButtons(sections = []) {
  const buttons = Array.isArray(sections)
    ? sections.filter((s) => s?.type === "BUTTON")
    : [];
  if (buttons.length === 0) return;

  const primary =
    buttons.find((s) => s?.setting?.role === "primaryCta") || buttons[0];
  const secondary =
    buttons.find((s) => s?.setting?.role === "secondaryCta") ||
    buttons.find((s) => s !== primary) ||
    buttons[1];

  if (primary?.setting) {
    primary.setting.role = "primaryCta";
    primary.setting.btn_type = primary.setting.btn_type || { type: "text" };
    primary.setting.display = {
      variant: BUTTON_CTA_VARIANT.FILLED_DARK,
      fullWidth: true,
      ...(primary.setting.display || {}),
    };
    primary.setting.action = AI_UPSELL_PRIMARY_CTA_ACTION;
  }

  if (secondary?.setting) {
    secondary.setting.role = "secondaryCta";
    secondary.setting.btn_type = secondary.setting.btn_type || { type: "text" };
    secondary.setting.display = {
      variant: BUTTON_CTA_VARIANT.OUTLINE_MUTED,
      fullWidth: true,
      ...(secondary.setting.display || {}),
    };
    secondary.setting.action = { type: "close_popup" };
  }
}
